<template>
  <a class="image-with-link" :href="link" :target="target">
    <div class="image-with-link__container">
      <c-image
        :image-mobile="imageMobile"
        :image-tablet="imageTablet"
        :image-desktop="imageDesktop"
        :alt="alt"
        :max-size="maxSize"
        class="image-with-link__image"
      />
    </div>

    <c-text
      :color="textColor"
      :size="textSize"
      :weight="textWeight"
      :align="textAlign"
      class="c-image__text"
    >
      <slot name="text" />
    </c-text>
  </a>
</template>

<script>
import CImage from '../../00_v2/image/image.vue'
import CText from '../../00_v2/text/text.vue'

export default {
  name: 'image-with-link',
  components: {
    CImage,
    CText,
  },
  props: {
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    maxSize: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    link: {
      type: String,
    },
    target: {
      type: String
    },
    textColor: {
      type: String,
      default: '#333333',
    },
    textSize: {
      type: String,
      default: 'xs',
      description: '(xs / sm / md / lg / xl)',
    },
    textWeight: {
      type: String,
      default: 'normal',
      description: '(bolder / lighter / normal)',
    },
    textAlign: {
      type: String,
      default: 'left',
      description: '(left / center / right)',
    },
  },
}
</script>

<style lang="scss">
.image-with-link {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &__container {
    overflow: hidden;
  }

  &__image {
    transition: all 0.8s;

    &:hover {
      transform: scale(1.08);
    }
  }
}
</style>
